import React, { useState } from 'react';
import Header from '../Header';
import LeftNavigationBar from '../LeftNavigationBar';
import { useStyles } from './styles';
import Notifications from '../Notifications';

interface PageContainerProps {
    children?: React.ReactNode;
    /** Extra styles for the scrolling page area (rarely needed; prefer layout inside the page). */
    contentStyle?: React.CSSProperties;
    /** Center the page in the design system's content column (`layout.contentMaxWidth`). Pages built with PageHeader/Panel pass it; legacy pages stay full width. */
    constrained?: boolean;
}

/** App shell: top bar, side navigation (drawer under 768px) and the scrolling page area. */
const PageContainer = ({ children, contentStyle, constrained = false }: PageContainerProps) => {
    const classes = useStyles();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <div className={classes.root}>
            <Notifications />
            <Header onMenuToggle={() => setMobileMenuOpen((v) => !v)} mobileMenuOpen={mobileMenuOpen} />
            <div className={classes.contentContainer} data-flex-main>
                <LeftNavigationBar isMobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />
                {mobileMenuOpen && <div className={classes.backdrop} onClick={() => setMobileMenuOpen(false)} aria-hidden="true" />}
                <main className={classes.pageContent} style={contentStyle}>
                    <div className={constrained ? classes.pageInner : undefined}>{children}</div>
                </main>
            </div>
        </div>
    );
};

export default PageContainer;
